import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import TokensPanelFull from '../containers/TokensPanelFull';
import TokensPanelNarrow from '../containers/TokensPanelNarrow';

const TokensPanel = ({ configuration }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: TokensPanelFull, narrow: TokensPanelNarrow }}
  />
);

export default TokensPanel;
